// extracted by mini-css-extract-plugin
export default {"pageContainer":"ArticlePage_pageContainer__sMlLs"};